// import React, { useState } from "react";
// import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
// import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
// import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
// import {
//   Box,
//   Stack,
//   Typography,
//   Button,
//   Card,
//   CardContent,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Switch,
//   FormControlLabel,
//   IconButton,
//   Avatar,
//   Divider,
//   Grid,
//   Snackbar,
//   Alert,
//   Paper,
//   Select,
//   MenuItem,
//   InputLabel,
//   FormControl,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import SaveIcon from "@mui/icons-material/Save";
// import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
// import OutboxIcon from "@mui/icons-material/Outbox";

// const sectionMeta = {
//   MedicalTest: { group: "Recommandations", key: "MedicalTests" },
//   Vaccination: { group: "Recommandations", key: "Vaccinations" },
//   PlanMasterMedicalTest: { group: "PlanMaster", key: "Add" },
//   PlanMasterVaccination: { group: "PlanMaster", key: "Update" },
//   video: { key: "Videos" },
//   post: { key: "Posts" },
//   BlogsLetters: { key: "Blogs" },
// };

// const initialSections = [
//   {
//     id: "MedicalTest",
//     notifyLabel: "Medical Test Notification:",
//     enabled: true,
//     msgType: "default",
//     title: "",
//     Message: "",
//   },
//   {
//     id: "Vaccination",
//     notifyLabel: "Vaccination Notification:",
//     enabled: true,
//     msgType: "default",
//     title: "",
//     Message: "",
//   },
//   {
//     id: "PlanMasterMedicalTest",
//     notifyLabel: "Medical Test Notification:",
//     enabled: true,
//     msgType: "default",
//     title: "",
//     Message: "",
//   },
//   {
//     id: "PlanMasterVaccination",
//     notifyLabel: "Vaccination Notification:",
//     enabled: true,
//     msgType: "default",
//     title: "",
//     Message: "",
//   },
//   // {
//   //   id: "video",
//   //   sectionTitle: "Manage Video Notification",
//   //   notifyLabel: "Video Notification:",
//   //   enabled: true,
//   //   msgType: "default",
//   //   title: "",
//   //   Message: "",
//   // },
//   // {
//   //   id: "post",
//   //   sectionTitle: "Manage Post Notification",
//   //   notifyLabel: "Post Notification:",
//   //   enabled: true,
//   //   msgType: "default",
//   //   title: "",
//   //   Message: "",
//   // },
//   // {
//   //   id: "BlogsLetters",
//   //   sectionTitle: "Manage Blogs and Newsletter Notification",
//   //   notifyLabel: "Blogs & Newsletter Notification:",
//   //   enabled: true,
//   //   msgType: "default",
//   //   title: "",
//   //   Message: "",
//   // },

// ];

// // Flat state item -> API item (capitalized keys)
// const toApiItem = (section) => ({
//   MsgType: section.msgType,
//   Title: section.title,
//   Message: section.Message,
//   Enabled: section.enabled,
// });

// // Falls back to sane defaults if a key is missing from the response.
// const fromApiItem = (apiItem) => ({
//   msgType: apiItem?.MsgType ?? "default",
//   title: apiItem?.Title ?? "",
//   Message: apiItem?.Message ?? "",
//   enabled: apiItem?.Enabled ?? true,
// });

// // Flat sections array -> nested API JSON, using sectionMeta as the map.
// const buildPayload = (sections) => {
//   const payload = {};

//   sections.forEach((section) => {
//     const meta = sectionMeta[section.id];
//     if (!meta) return;

//     const apiItem = toApiItem(section);

//     if (meta.group) {
//       payload[meta.group] = payload[meta.group] || {};
//       payload[meta.group][meta.key] = apiItem;
//     } else {
//       payload[meta.key] = apiItem;
//     }
//   });

//   return payload;
// };

// // enabled/msgType/title/Message from the response by id.
// const parseApiData = (apiData, baseSections = initialSections) => {
//   return baseSections.map((section) => {
//     const meta = sectionMeta[section.id];
//     if (!meta) return section;

//     const raw = meta.group
//       ? apiData?.[meta.group]?.[meta.key]
//       : apiData?.[meta.key];

//     if (!raw) return section;

//     return { ...section, ...fromApiItem(raw) };
//   });
// };

// export default function NotificationSettings() {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [sections, setSections] = useState(initialSections);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   const [modalData, setModalData] = useState({
//     userType: "All",
//     title: "",
//     Message: "",
//     imageUrl: "",
//   });

//   const openModal = () => {
//     setModalData({
//       userType: "All",
//       title: "",
//       Message: "",
//       imageUrl: "",
//     });
//     setErrors({});
//     setIsModalOpen(true);
//   };

//   const closeModal = () => setIsModalOpen(false);

//   const handleModalChange = (e) => {
//     const { name, value } = e.target;
//     setModalData((prev) => ({ ...prev, [name]: value }));
//     setErrors((prev) => ({ ...prev, [name]: "" }));
//   };

//   const validateModal = () => {
//     const newErrors = {};

//     if (!modalData.title.trim()) {
//       newErrors.title = "Title is required.";
//     }

//     if (!modalData.Message.trim()) {
//       newErrors.Message = "Message is required.";
//     }

//     // Image URL is optional
//     if (modalData.imageUrl.trim()) {
//       try {
//         new URL(modalData.imageUrl);
//       } catch {
//         newErrors.imageUrl = "Enter a valid URL.";
//       }
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleModalSave = () => {
//     if (!validateModal()) return;
//     // setNotifications((prev) => [...prev, { ...modalData, id: Date.now() }]);
//     setIsModalOpen(false);
//     setSnackbar({
//       open: true,
//       message: "Custom notification sent.",
//       severity: "success",
//     });
//   };

//   // identically for every id in `sections`, mapped or not.
//   const toggleSection = (id) => {
//     setSections((prev) =>
//       prev.map((section) => {
//         if (section.id !== id) return section;
//         const nextEnabled = !section.enabled;
//         return {
//           ...section,
//           enabled: nextEnabled,
//           ...(nextEnabled
//             ? {}
//             : { msgType: "default", title: "", Message: "" }),
//         };
//       }),
//     );
//   };

//   const handleMsgTypeChange = (id, value) => {
//     setSections((prev) =>
//       prev.map((section) =>
//         section.id === id
//           ? {
//               ...section,
//               msgType: value,
//               ...(value === "default" ? { title: "", Message: "" } : {}),
//             }
//           : section,
//       ),
//     );
//   };

//   const handleSectionFieldChange = (id, field, value) => {
//     setSections((prev) =>
//       prev.map((section) =>
//         section.id === id ? { ...section, [field]: value } : section,
//       ),
//     );
//   };

//   const handleFormSave = async () => {
//     const payload = buildPayload(sections);
//     console.log("Payload to send:", payload);

//     // await fetch("/api/notification-settings", {
//     //   method: "POST",
//     //   headers: { "Content-Type": "application/json" },
//     //   body: JSON.stringify(payload),
//     // });

//     setSnackbar({
//       open: true,
//       message: "Notification settings saved.",
//       severity: "success",
//     });
//   };

//   const closeSnackbar = () => setSnackbar((prev) => ({ ...prev, open: false }));

//   // Purely presentational, no special logic; each call is independent.
//   const renderRow = (section) => {
//     const isCustom = section.msgType === "custom";
//     const fieldsEnabled = section.enabled && isCustom;

//     return (
//       <Grid container spacing={4} alignItems="center">
//         {/* Notification Label */}
//         <Grid item xs={12} md={10}>
//           <Stack direction="row" alignItems="center" spacing={2}>
//             <Typography variant="body1" fontWeight={500}>
//               {section.notifyLabel}
//             </Typography>

//             <FormControlLabel
//               sx={{ m: 0 }}
//               labelPlacement="start"
//               label={section.enabled ? "Enabled" : "Disabled"}
//               control={
//                 <Switch
//                   checked={section.enabled}
//                   onChange={() => toggleSection(section.id)}
//                 />
//               }
//             />
//           </Stack>
//         </Grid>

//         {/* Message Type */}
//         {/* <Grid item xs={12} sm={6} md={3}>
//           <FormControl fullWidth size="small" disabled={!section.enabled}>
//             <InputLabel id={`${section.id}-msgtype-label`}>
//               Message Type
//             </InputLabel>
//             <Select
//               labelId={`${section.id}-msgtype-label`}
//               label="Message Type"
//               value={section.msgType}
//               onChange={(e) => handleMsgTypeChange(section.id, e.target.value)}
//             >
//               <MenuItem value="default">Default</MenuItem>
//               <MenuItem value="custom">Custom</MenuItem>
//             </Select>
//           </FormControl>
//         </Grid> */}

//         {/* Title */}
//         {/* <Grid item xs={12} md={5}>
//           <TextField
//             fullWidth
//             size="small"
//             multiline
//             rows={2}
//             label="Title"
//             placeholder="Enter title"
//             value={section.title}
//             disabled={!fieldsEnabled}
//             inputProps={{ maxLength: 100 }}
//             helperText={`${section.title?.length || 0}/100`}
//             onChange={(e) =>
//               handleSectionFieldChange(section.id, "title", e.target.value)
//             }
//           />
//         </Grid> */}

//         {/* Message */}
//         {/* <Grid item xs={12}>
//           <TextField
//             fullWidth
//             size="small"
//             label="Message"
//             multiline
//             rows={3}
//             placeholder="Enter Message"
//             value={section.Message}
//             disabled={!fieldsEnabled}
//             inputProps={{ maxLength: 250 }}
//             helperText={`${section.Message?.length || 0}/250`}
//             onChange={(e) =>
//               handleSectionFieldChange(
//                 section.id,
//                 "Message",
//                 e.target.value,
//               )
//             }
//           />
//         </Grid> */}
//       </Grid>
//     );
//   };

//   // (PlanMasterMedicalTest, PlanMasterVaccination).
//   const renderGroupCard = (heading, items) => (
//     <Grid item xs={6}>
//       <Card
//         variant="outlined"
//         sx={{
//           borderRadius: 3,
//           width: "100%",
//           mb: 2,
//           borderColor: "grey.300",
//           transition: "box-shadow 0.2s ease, border-color 0.3s ease",
//           "&:hover": { boxShadow: 2, borderColor: "primary.light" },
//         }}
//       >
//         <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
//           <Stack
//             direction="row"
//             alignItems="center"
//             spacing={1.5}
//             sx={{ mb: 2 }}
//           >
//             <Avatar
//               sx={{
//                 bgcolor: "primary.light",
//                 color: "primary.dark",
//                 width: 36,
//                 height: 36,
//               }}
//             >
//               <NotificationsActiveIcon fontSize="small" />
//             </Avatar>
//             <Typography variant="h6" fontWeight={600} align="left">
//               {heading}
//             </Typography>
//           </Stack>

//           <Divider sx={{ mb: 2 }} />

//           {items.map((item, idx) => (
//             <React.Fragment key={item.id}>
//               {renderRow(item)}
//               {idx < items.length - 1 && <Divider sx={{ my: 3 }} />}
//             </React.Fragment>
//           ))}
//         </CardContent>
//       </Card>
//     </Grid>
//   );

//   // Pull grouped items out by id (explicit, no magic).
//   const medicalTest = sections.find((s) => s.id === "MedicalTest");
//   const vaccination = sections.find((s) => s.id === "Vaccination");
//   const PlanMasterMedicalTest = sections.find((s) => s.id === "PlanMasterMedicalTest");
//   const PlanMasterVaccination = sections.find((s) => s.id === "PlanMasterVaccination");

//   const groupedIds = [
//     "MedicalTest",
//     "Vaccination",
//     "PlanMasterMedicalTest",
//     "PlanMasterVaccination",
//   ];
//   const otherSections = sections.filter((s) => !groupedIds.includes(s.id));

//   return (
//     <>
//       {" "}
//       <Grid
//         container
//         lg={12}
//         component={Paper}
//         textAlign={"center"}
//         sx={{
//           width: "100%",
//           px: 5,
//           display: "flex",
//           flexDirection: "row",
//           alignItems: "center",
//           justifyContent: "space-between",
//           mb: 2,
//         }}
//         elevation={4}
//       >
//         <Typography
//           className="slide-in-text"
//           width={"100%"}
//           textAlign="center"
//           textTransform="uppercase"
//           fontWeight="bold"
//           padding={1}
//           noWrap
//         >
//           Manage Notification Settings
//         </Typography>
//       </Grid>
//       <Box
//         sx={{ width: "100%", maxWidth: 1600, mx: "auto", p: { xs: 2, sm: 4 } }}
//       >
//         {/* ---------------- Header ---------------- */}
//         <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 3 }}>
//           <Button
//             variant="contained"
//             onClick={openModal}
//             type="text"
//             size="medium"
//             sx={{
//               pr: 1,
//               color: "white",
//               backgroundColor: "#5C5CFF",
//               boxShadow: 5,
//               "&:hover": {
//                 backgroundColor: "#E6E6FA",
//                 border: "1px solid #5C5CFF",
//                 color: "#5C5CFF",
//               },
//               "& .MuiButton-label": {
//                 display: "flex",
//                 alignItems: "center",
//               },
//               "& .MuiSvgIcon-root": {
//                 marginRight: "10px",
//               },
//             }}
//             startIcon={<OutboxIcon />}
//           >
//             Send custom notification
//           </Button>
//         </Box>

//         {/* ---------------- Main form: section wise ---------------- */}
//         <Box
//           component="form"
//           onSubmit={(e) => e.preventDefault()}
//           sx={{ width: "100%" }}
//         >
//           <Grid container spacing={3} >

//             {/* Recommandations group -> MedicalTest + Vaccination */}
//             {/* {medicalTest &&
//               vaccination &&
//               renderGroupCard("Recommendations Notification", [
//                 medicalTest,
//                 vaccination,
//               ])
//               } */}

//             {/* PlanMaster group -> Add + Update */}
//             {PlanMasterMedicalTest &&
//               PlanMasterVaccination &&
//               renderGroupCard("Plan Master Notification", [
//                 PlanMasterMedicalTest,
//                 PlanMasterVaccination,
//               ])}

//             {/* Remaining flat sections (Videos, Posts, Blogs) */}
//             {otherSections.map((section) => (
//               <Grid item xs={6} key={section.id}>
//                 <Card
//                   variant="outlined"
//                   sx={{
//                     borderRadius: 3,
//                     width: "100%",
//                     mb: 2,
//                     borderColor: "grey.300",
//                     transition: "box-shadow 0.2s ease, border-color 0.3s ease",
//                     "&:hover": { boxShadow: 2, borderColor: "primary.light" },
//                   }}
//                 >
//                   <CardContent sx={{ p: { xs: 5, sm: 6 } }}>
//                     <Stack
//                       direction="row"
//                       alignItems="center"
//                       spacing={1.5}
//                       sx={{ mb: 2 }}
//                     >
//                       <Avatar
//                         sx={{
//                           bgcolor: "primary.light",
//                           color: "primary.dark",
//                           width: 36,
//                           height: 36,
//                         }}
//                       >
//                         <NotificationsActiveIcon fontSize="small" />
//                       </Avatar>
//                       <Typography variant="h6" fontWeight={600} align="left">
//                         {section.sectionTitle}
//                       </Typography>
//                     </Stack>

//                     <Divider sx={{ mb: 2 }} />

//                     {renderRow(section)}
//                   </CardContent>
//                 </Card>
//               </Grid>
//             ))}

//             <Box
//               sx={{
//                 position: "fixed",
//                 bottom: { xs: 16, sm: 20, md: 24 },
//                 zIndex: 1300,
//               }}
//             >
//               <Button
//                 variant="contained"
//                 color="primary"
//                 startIcon={<SaveIcon />}
//                 onClick={handleFormSave}
//               >
//                 Save
//               </Button>
//             </Box>
//           </Grid>
//         </Box>

//         {/* ---------------- Add notification modal ---------------- */}

//         <Dialog
//           open={isModalOpen}
//           onClose={closeModal}
//           fullWidth
//           maxWidth="xs"
//           PaperProps={{
//             sx: { borderRadius: 3 },
//           }}
//         >
//           <DialogTitle
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               py: 2,
//               px: 3,
//             }}
//           >
//             <Stack direction="row" spacing={1.25} alignItems="center">
//               <Box
//                 sx={{
//                   width: 36,
//                   height: 36,
//                   borderRadius: "50%",
//                   bgcolor: "primary.main",
//                   color: "#fff",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//               >
//                 <NotificationsActiveOutlinedIcon fontSize="small" />
//               </Box>
//               <Box>
//                 <Typography
//                   variant="subtitle1"
//                   fontWeight={600}
//                   lineHeight={1.2}
//                 >
//                   Send Custom Notification
//                 </Typography>
//                 <Typography variant="caption" color="text.secondary">
//                   Compose and push a message to your users
//                 </Typography>
//               </Box>
//             </Stack>

//             <IconButton onClick={closeModal} size="small">
//               <CloseIcon fontSize="small" />
//             </IconButton>
//           </DialogTitle>
//           <Divider />

//           <DialogContent sx={{ px: 3, py: 3 }}>
//             <Stack spacing={3}>
//               {/* --- Message section --- */}
//                 <Typography
//                   variant="overline"
//                   color="text.secondary"
//                   fontWeight={600}
//                   sx={{ letterSpacing: 0.6 }}
//                 >
//                   Message
//                 </Typography>

//                 <Stack spacing={2} sx={{ mt: 1 }}>
//                   <TextField
//                     name="title"
//                     label="Enter Title"
//                     size="small"
//                     placeholder="Send Custom Notification Title"
//                     value={modalData.title}
//                     onChange={handleModalChange}
//                     error={!!errors.title}
//                     inputProps={{ maxLength: 100 }}
//                     helperText={
//                       errors.title || `${modalData.title?.length || 0}/100`
//                     }
//                     FormHelperTextProps={{
//                       sx: { textAlign: "right", mx: 0, mt: 0.5 },
//                     }}
//                     fullWidth
//                   />

//                   <TextField
//                     name="Message"
//                     label="Enter Message"
//                     placeholder="Send Custom Notification Message"
//                     value={modalData.Message}
//                     onChange={handleModalChange}
//                     error={!!errors.Message}
//                     inputProps={{ maxLength: 250 }}
//                     helperText={
//                       errors.Message ||
//                       `${modalData.Message?.length || 0}/250`
//                     }
//                     FormHelperTextProps={{
//                       sx: { textAlign: "right", mx: 0, mt: 0.5 },
//                     }}
//                     multiline
//                     rows={3}
//                     fullWidth
//                   />
//                 </Stack>

//               {/* --- Audience section --- */}
//                 <FormControl fullWidth size="small">
//                   <InputLabel id="user-type-label">Select users</InputLabel>
//                   <Select
//                     labelId="user-type-label"
//                     name="userType"
//                     value={modalData.userType}
//                     label="Select users"
//                     onChange={handleModalChange}
//                   >
//                     <MenuItem value="All">All users</MenuItem>
//                     <MenuItem value="FU">Free users</MenuItem>
//                     <MenuItem value="PU">Premium users</MenuItem>
//                   </Select>
//                 </FormControl>

//                 <TextField
//                   name="imageUrl"
//                   label="Image URL"
//                   size="small"
//                   placeholder="https://example.com/image.png"
//                   value={modalData.imageUrl}
//                   onChange={handleModalChange}
//                   error={!!errors.imageUrl}
//                   helperText={errors.imageUrl}
//                   fullWidth
//                 />
//             </Stack>
//           </DialogContent>

//           <Divider />

//           <DialogActions sx={{ px: 3, py: 2 }}>
//             <Button
//               variant="contained"
//               onClick={handleModalSave}
//               disableElevation
//               sx={{ px: 3 }}
//             >
//               Send Notification
//             </Button>
//           </DialogActions>
//         </Dialog>
//         {/* ---------------- Feedback toast ---------------- */}
//         <Snackbar
//           open={snackbar.open}
//           autoHideDuration={3000}
//           onClose={closeSnackbar}
//           anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         >
//           <Alert
//             onClose={closeSnackbar}
//             severity={snackbar.severity}
//             variant="filled"
//             sx={{ width: "100%" }}
//           >
//             {snackbar.message}
//           </Alert>
//         </Snackbar>
//       </Box>
//     </>
//   );
// }

import React, { useEffect, useState } from "react";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
import VaccinesOutlinedIcon from "@mui/icons-material/VaccinesOutlined";
import {
  Box,
  Stack,
  Typography,
  Button,
  Card,
  CardContent,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Switch,
  FormControlLabel,
  IconButton,
  Avatar,
  Divider,
  Grid,
  Snackbar,
  Alert,
  Paper,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import OutboxIcon from "@mui/icons-material/Outbox";
import axios from "axios";
import Swal from "sweetalert2";
import { BASE_URL } from "../../Constant";
import Loader from "../../components/Loader";

const initialSections = [
  {
    id: "MedicalTest",
    notifyLabel: "Medical Test Notification",
    description: "Receive reminders for upcoming medical tests and due dates.",
    icon: ScienceOutlinedIcon,
    enabled: true,
    msgType: "default",
    title: "",
    Message: "",
  },
  {
    id: "Vaccination",
    notifyLabel: "Vaccination Notification",
    description: "Receive reminders for upcoming vaccination schedules.",
    icon: VaccinesOutlinedIcon,
    enabled: true,
    msgType: "default",
    title: "",
    Message: "",
  },
];

// Flat state item -> API item (capitalized keys)
const toApiItem = (section) => ({
  MsgType: section.msgType,
  Title: section.title,
  Message: section.Message,
  Enabled: section.enabled,
});

// Falls back to sane defaults if a key is missing from the response.
const fromApiItem = (apiItem) => ({
  msgType: apiItem?.MsgType ?? "default",
  title: apiItem?.Title ?? "",
  Message: apiItem?.Message ?? "",
  enabled: apiItem?.Enabled ?? true,
});

export default function NotificationSettings() {
  const [loaderOpen, setLoaderOpen] = React.useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [sections, setSections] = useState(initialSections);
  const [customEnabled, setCustomEnabled] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [modalData, setModalData] = useState({
    userType: "ALL",
    title: "",
    Message: "",
    imageUrl: "",
  });

  const openModal = () => {
    setModalData({
      userType: "ALL",
      title: "",
      Message: "",
      imageUrl: "",
    });
    setErrors({});
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  const handleModalChange = (e) => {
    const { name, value } = e.target;
    setModalData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateModal = () => {
    const newErrors = {};

    if (!modalData.title.trim()) {
      newErrors.title = "Title is required.";
    }

    if (!modalData.Message.trim()) {
      newErrors.Message = "Message is required.";
    }

    // Image URL is optional
    if (modalData.imageUrl.trim()) {
      try {
        new URL(modalData.imageUrl);
      } catch {
        newErrors.imageUrl = "Enter a valid URL.";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const getApiToken = async () => {
    const data = sessionStorage.getItem("userData");
    if (data !== null) {
      const fetchedData = JSON.parse(data);
      return fetchedData.Token;
    }
  };

  const HandleGetData = async () => {
    const token = await getApiToken();

    try {
      const resp = await axios.get(`${BASE_URL}notificationsetting`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      const getdata = resp.data.values;

      if (getdata) {
        setSections((prev) =>
          prev.map((section) => {
            if (
              section.id === "MedicalTest" &&
              getdata.Recommandations?.MedicalTests
            ) {
              return {
                ...section,
                msgType:
                  getdata.Recommandations.MedicalTests.MsgType ?? "default",
                enabled: getdata.Recommandations.MedicalTests.Enabled ?? true,
              };
            }
            if (
              section.id === "Vaccination" &&
              getdata.Recommandations?.Vaccinations
            ) {
              return {
                ...section,
                msgType:
                  getdata.Recommandations.Vaccinations.MsgType ?? "default",
                enabled: getdata.Recommandations.Vaccinations.Enabled ?? true,
              };
            }
            return section;
          }),
        );

        setCustomEnabled(getdata.Custom?.Enabled ?? false);
      }
    } catch (error) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Failed",
        text: "Could not load notification settings.",
      });
    }
  };

  useEffect(() => {
    HandleGetData();
  }, []);

  const handleModalSave = async () => {
    if (!validateModal()) return;

    const token = await getApiToken();
    const payload = {
      Title: modalData.title,
      Message: modalData.Message,
      UserType: modalData.userType,
      ImgLink: modalData.imageUrl,
    };
    setLoaderOpen(true);
    console.log("Payload", payload);

    axios
      .post(`${BASE_URL}notification/Custom`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      })
      .then((response) => {
        setLoaderOpen(false);
        if (response.data.status) {
          Swal.fire({
            position: "center",
            icon: "success",
            toast: true,
            title: "Custom Notification Sent Successfully",
            showConfirmButton: false,
            timer: 1500,
          });
          closeModal();
          setIsModalOpen(false);
          
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            toast: true,
            title: "Failed",
            text: response.data.message,
            showConfirmButton: true,
          });
        }
      })
      .catch((error) => {
        setLoaderOpen(false);
        Swal.fire({
          position: "center",
          icon: "error",
          toast: true,
          title: "Failed",
          text: error.message,
          showConfirmButton: true,
        });
      });
  };

  // identically for every id in `sections`, mapped or not.
  const toggleSection = (id) => {
    setSections((prev) =>
      prev.map((section) => {
        if (section.id !== id) return section;
        const nextEnabled = !section.enabled;
        return {
          ...section,
          enabled: nextEnabled,
          ...(nextEnabled
            ? {}
            : { msgType: "default", title: "", Message: "" }),
        };
      }),
    );
  };

  const handleMsgTypeChange = (id, value) => {
    setSections((prev) =>
      prev.map((section) =>
        section.id === id
          ? {
              ...section,
              msgType: value,
              ...(value === "default" ? { title: "", Message: "" } : {}),
            }
          : section,
      ),
    );
  };

  const handleCustomToggle = () => {
    setCustomEnabled((prev) => !prev);
  };

  // Pull grouped items out by id (explicit, no magic).
  const medicalTest = sections.find((s) => s.id === "MedicalTest");
  const vaccination = sections.find((s) => s.id === "Vaccination");

  const handleFormSave = async () => {
    const token = await getApiToken();

    const payload = {
      Recommandations: {
        MedicalTests: {
          MsgType: medicalTest.msgType,
          Enabled: medicalTest.enabled,
        },
        Vaccinations: {
          MsgType: vaccination.msgType,
          Enabled: vaccination.enabled,
        },
      },
      Custom: {
        Enabled: customEnabled,
      },
    };

    setLoaderOpen(true);

    try {
      const response = await axios.patch(
        `${BASE_URL}notificationsetting`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoaderOpen(false);

      if (response.data.status) {
        Swal.fire({
          position: "center",
          icon: "success",
          toast: true,
          title: "Notification Settings Saved Successfully",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Failed",
          text: response.data.message,
        });
      }
    } catch (error) {
      setLoaderOpen(false);

      Swal.fire({
        position: "center",
        icon: "error",
        title: "Failed",
        text: error.message,
      });
    }
  };

  const closeSnackbar = () => setSnackbar((prev) => ({ ...prev, open: false }));

  // Flat sections array -> API payload, using toApiItem per section.
  const buildPayload = (currentSections) => {
    const payload = {};
    currentSections.forEach((section) => {
      payload[section.id] = toApiItem(section);
    });
    return payload;
  };

  // Purely presentational, no special logic; each call is independent.
  const renderRow = (section, isLast) => {
    const RowIcon = section.icon || NotificationsActiveOutlinedIcon;

    return (
      <Box key={section.id}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 2,
            py: 2.5,
          }}
        >
          {/* Icon */}
          <Avatar
            variant="rounded"
            sx={{
              width: 48,
              height: 48,
              borderRadius: 2,
              bgcolor: "primary.50",
              color: "primary.main",
            }}
          >
            <RowIcon fontSize="small" />
          </Avatar>

          {/* Label + description */}
          <Box sx={{ flex: 1, minWidth: 200 }}>
            <Typography variant="body1" fontWeight={600} color="text.primary">
              {section.notifyLabel}
            </Typography>
            {section.description && (
              <Typography variant="body2" color="text.secondary">
                {section.description}
              </Typography>
            )}
          </Box>

          {/* Status chip + divider + switch */}
          <Stack direction="row" alignItems="center" spacing={2}>
            <Chip
              label={section.enabled ? "Enabled" : "Disabled"}
              size="small"
              sx={{
                fontWeight: 600,
                bgcolor: section.enabled ? "success.50" : "grey.100",
                color: section.enabled ? "success.dark" : "text.secondary",
              }}
            />
            <Divider orientation="vertical" flexItem sx={{ my: 0.5 }} />
            <Switch
              checked={section.enabled}
              onChange={() => toggleSection(section.id)}
            />
          </Stack>
        </Box>
        {!isLast && <Divider />}
      </Box>
    );
  };

  const renderGroupCard = (heading, description, items) => (
    <Grid item xs={12}>
      <Card
        variant="outlined"
        sx={{
          borderRadius: 3,
          borderColor: "divider",
        }}
      >
        <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Avatar
              variant="rounded"
              sx={{
                bgcolor: "primary.main",
                color: "#fff",
                width: 44,
                height: 44,
                borderRadius: 2,
              }}
            >
              <NotificationsActiveIcon fontSize="small" />
            </Avatar>
            <Box>
              <Typography variant="h6" fontWeight={700}>
                {heading}
              </Typography>
              {description && (
                <Typography variant="body2" color="text.secondary">
                  {description}
                </Typography>
              )}
            </Box>
          </Stack>

          <Divider sx={{ mt: 3 }} />

          <Box>
            {items.map((item, idx) =>
              renderRow(item, idx === items.length - 1),
            )}
          </Box>
        </CardContent>
      </Card>
    </Grid>
  );

  return (
    <>
      {loaderOpen && <Loader open={loaderOpen} />}
      <Grid
        container
        component={Paper}
        textAlign={"center"}
        elevation={4}
        sx={{
          width: "100%",
          px: 5,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Typography
          className="slide-in-text"
          width={"100%"}
          textAlign="center"
          textTransform="uppercase"
          fontWeight="bold"
          // color={"#5C5CFF"}
          padding={1}
          noWrap
        >
          Manage Notification
        </Typography>
      </Grid>
      <Box
        sx={{
          width: "100%",
          maxWidth: 1100,
          mx: "auto",
          p: { xs: 2, sm: 4 },
        }}
      >
        {/* ---------------- Page header ---------------- */}
        {/* <Paper
          variant="outlined"
          sx={{
            borderRadius: 3,
            borderColor: "divider",
            px: { xs: 2.5, sm: 3.5 },
            py: 3,
            mb: 2.5,
            display: "flex",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Avatar
            variant="rounded"
            sx={{
              width: 48,
              height: 48,
              borderRadius: 2,
              bgcolor: "primary.main",
              color: "#fff",
            }}
          >
            <NotificationsActiveOutlinedIcon />
          </Avatar>
          <Box>
            <Typography variant="h6" fontWeight={700} color="text.primary">
              Manage Notification Settings
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Configure and manage notification preferences for Plan Master.
            </Typography>
          </Box>
        </Paper> */}

        {/* ---------------- Custom notification card ---------------- */}
        <Paper
          variant="outlined"
          sx={{
            borderRadius: 3,
            borderColor: "divider",
            px: { xs: 2.5, sm: 3.5 },
            py: 2.5,
            mb: 2.5,
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Box>
            <Typography
              variant="subtitle1"
              fontWeight={700}
              color="text.primary"
            >
              Enable Custom Notification
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Turn on to enable custom notifications
            </Typography>
          </Box>

          <Stack direction="row" alignItems="center" spacing={2}>
            <Switch checked={customEnabled} onChange={handleCustomToggle} />

            <Button
              variant="contained"
              onClick={openModal}
              disabled={!customEnabled}
              sx={{
                color: "white",
                backgroundColor: "#5C5CFF",
                borderRadius: 2,
                px: 2.5,
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#4a4ae0",
                  boxShadow: "none",
                },
              }}
              startIcon={<OutboxIcon />}
            >
              Send Custom Notification
            </Button>
          </Stack>
        </Paper>

        {/* ---------------- Main form: section wise ---------------- */}
        <Box
          component="form"
          onSubmit={(e) => e.preventDefault()}
          sx={{ width: "100%" }}
        >
          <Grid container spacing={3}>
            {medicalTest &&
              vaccination &&
              renderGroupCard(
                "Recommandation Notification",
                "Manage notification preferences for different reminder types.",
                [medicalTest, vaccination],
              )}
          </Grid>

          <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 4 }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={handleFormSave}
              sx={{
                borderRadius: 2,
                px: 3,
                backgroundColor: "#5C5CFF",
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#4a4ae0",
                  boxShadow: "none",
                },
              }}
            >
              Save Changes
            </Button>
          </Box>
        </Box>

        {/* ---------------- Add notification modal ---------------- */}
        <Dialog
          open={isModalOpen}
          onClose={closeModal}
          fullWidth
          maxWidth="xs"
          PaperProps={{
            sx: { borderRadius: 3 },
          }}
        >
          <DialogTitle
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              py: 2,
              px: 3,
            }}
          >
            <Stack direction="row" spacing={1.25} alignItems="center">
              <Box
                sx={{
                  width: 36,
                  height: 36,
                  borderRadius: "50%",
                  bgcolor: "primary.main",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <NotificationsActiveOutlinedIcon fontSize="small" />
              </Box>
              <Box>
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  lineHeight={1.2}
                >
                  Send Custom Notification
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Compose and push a message to your users
                </Typography>
              </Box>
            </Stack>

            <IconButton onClick={closeModal} size="small">
              <CloseIcon fontSize="small" />
            </IconButton>
          </DialogTitle>
          <Divider />

          <DialogContent sx={{ px: 3, py: 3 }}>
            <Stack spacing={3}>
              {/* --- Message section --- */}
              <Typography
                variant="overline"
                color="text.secondary"
                fontWeight={600}
                sx={{ letterSpacing: 0.6 }}
              >
                Message
              </Typography>

              <Stack spacing={2} sx={{ mt: 1 }}>
                <Tooltip
                  title={modalData.title || "Enter Title"}
                  arrow
                  placement="top"
                >
                  <TextField
                    name="title"
                    label="Title"
                    size="small"
                    placeholder="Send Custom Notification Title"
                    value={modalData.title}
                    onChange={handleModalChange}
                    error={!!errors.title}
                    inputProps={{ maxLength: 100 }}
                    helperText={
                      errors.title || `${modalData.title?.length || 0}/100`
                    }
                    FormHelperTextProps={{
                      sx: { textAlign: "right", mx: 0, mt: 0.5 },
                    }}
                    fullWidth
                  />
                </Tooltip>
                <Tooltip
                  title={modalData.Message || "Enter Message"}
                  arrow
                  placement="bottom"
                >
                  <TextField
                    name="Message"
                    label="Message"
                    placeholder="Send Custom Notification Message"
                    value={modalData.Message}
                    onChange={handleModalChange}
                    error={!!errors.Message}
                    inputProps={{ maxLength: 250 }}
                    helperText={
                      errors.Message || `${modalData.Message?.length || 0}/250`
                    }
                    FormHelperTextProps={{
                      sx: { textAlign: "right", mx: 0, mt: 0.5 },
                    }}
                    multiline
                    rows={3}
                    fullWidth
                  />
                </Tooltip>
              </Stack>

              <FormControl fullWidth size="small">
                <InputLabel id="user-type-label">Select users</InputLabel>
                <Select
                  labelId="user-type-label"
                  name="userType"
                  value={modalData.userType}
                  label="Select users"
                  onChange={handleModalChange}
                >
                  <MenuItem value="ALL">All users</MenuItem>
                  <MenuItem value="FU">Free users</MenuItem>
                  <MenuItem value="PU">Premium users</MenuItem>
                </Select>
              </FormControl>

              <TextField
                name="imageUrl"
                label="Image URL"
                size="small"
                placeholder="https://example.com/image.png"
                value={modalData.imageUrl}
                onChange={handleModalChange}
                error={!!errors.imageUrl}
                helperText={errors.imageUrl}
                fullWidth
              />
            </Stack>
          </DialogContent>

          <Divider />

          <DialogActions sx={{ px: 3, py: 2 }}>
            <Button
              variant="contained"
              onClick={handleModalSave}
              disableElevation
              sx={{ px: 3 }}
            >
              Send Notification
            </Button>
          </DialogActions>
        </Dialog>

        {/* ---------------- Feedback toast ---------------- */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={closeSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={closeSnackbar}
            severity={snackbar.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );
}
